import React from 'react'

const Error = () => {
  return (
    <div className='flex justify-center items-center text-3xl text-red-700'>Error -404 Not found, chala ja  yaha se kuch nhi milega</div>
  )
}

export default Error